import { jsx as e, jsxs as m } from "react/jsx-runtime";
import { useMultiStyleConfig as a, Box as r } from "@chakra-ui/react";
import { CircleDotIcon as x, CircleCheckIcon as p } from "../../icons/componentIcons.mjs";
import { useStepsContext as f } from "./useStepsContext.mjs";
const C = /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "none", children: /* @__PURE__ */ e("circle", { cx: "10", cy: "10", r: "9", strokeWidth: "2", stroke: "black", fill: "none" }) }), w = ({ step: l = 0, stepState: c, ...n }) => {
  const o = a("Steps"), { componentClassPrefix: t } = f(), s = `${t}__step-icon`, i = {
    variant: "solid",
    size: "xl"
  };
  return c === "active" ? /* @__PURE__ */ e(x, { className: `${s}`, ...i, sx: o.icon, ...n }) : c === "complete" ? /* @__PURE__ */ e(p, { className: `${s}`, ...i, sx: o.icon, ...n }) : /* @__PURE__ */ m(r, { className: `${s}`, sx: o.icon, children: [
    C,
    /* @__PURE__ */ e(r, { className: `${t}__step-number`, children: l })
  ] });
};
export {
  w as StepIcon
};
